import { render, staticRenderFns } from "./tableForm.vue?vue&type=template&id=021d1e3e&scoped=true"
import script from "./tableForm.vue?vue&type=script&lang=js"
export * from "./tableForm.vue?vue&type=script&lang=js"
import style0 from "./tableForm.vue?vue&type=style&index=0&id=021d1e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d1e3e",
  null
  
)

export default component.exports